import userApi from "../apis/userApi";
import { apiCallBegin, apiCallSuccess, apiCallError } from "./loading";

export const ACTION_TYPES = {
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    LOGOUT: 'LOGOUT',
}

export const authenticate = (username, password) => dispatch => {
    dispatch(apiCallBegin());
    return userApi.user().login(username, password)
        .then(response => {
            localStorage.setItem('user', JSON.stringify(response.data));
            dispatch({
                type: ACTION_TYPES.LOGIN_SUCCESS,
                payload: response.data
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch({
                type: ACTION_TYPES.LOGIN_FAILURE,
                payload: err.data
            });
            dispatch(apiCallError());
            return Promise.reject(err);
        });
}

export const logout = () => dispatch => {
    dispatch({
        type: ACTION_TYPES.LOGOUT,
        payload: null
    });
    localStorage.removeItem('user');
    window.location = "/";
}